import React from 'react'
import { DesignedModal, Button } from '@clickcease/cc-client-components-lib'
import { useTranslation, Trans } from 'react-i18next'
import { NoteBold, NoteText, StyledLink } from '../ClickceaseMigrationBanner.styled'
import { useZendeskChat } from 'Hooks/zendesk/useZendeskChat'

type LastMessageModalProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  isError: boolean
}

export const LastMessageModal = ({ isOpen, setIsOpen, isError }: LastMessageModalProps) => {
  const { t } = useTranslation('limitedOfferBanner')
  const { openChat } = useZendeskChat()

  const title = t(`last-message-modal.${isError ? 'error' : 'success'}-title`)

  const buttonText = t(`last-message-modal.${isError ? 'error' : 'success'}-button`)

  const buttonAction = isError ? openChat : () => setIsOpen(false)

  const bodyContent = isError ? (
    <Trans
      t={t}
      i18nKey="last-message-modal.error-message"
      components={{ support: <StyledLink onClick={openChat} /> }}
    />
  ) : (
    <Trans
      t={t}
      i18nKey="last-message-modal.success-message"
      components={{ noteBold: <NoteBold />, note: <NoteText onClick={openChat} /> }}
    />
  )

  return (
    <DesignedModal
      title={title}
      onOpenChange={() => setIsOpen(false)}
      isOpen={isOpen}
      style={{ width: '572px' }}
      actions={<Button text={buttonText} onClick={buttonAction} />}
    >
      {bodyContent}
    </DesignedModal>
  )
}
